import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DefineBootboxId } from 'app/resources/classes';
import { PublicFormContact } from 'app/resources/classes/public-form-contact';
import { SendMailService } from 'app/resources/services/send-mail.service';
import { environment } from 'environments/environment';
import { finalize, first } from 'rxjs/operators';

@Component({
  selector: 'app-institucional',
  templateUrl: './institucional.component.html',
  styleUrls: ['./institucional.component.css']
})
export class InstitucionalComponent {

  public email: PublicFormContact;
  public processando: boolean;
  private bootboxAlertComId: DefineBootboxId;
  public commercialCommunication: PublicFormContact;
  public siteKey = environment.siteKey;

  constructor(
    private sendMailService: SendMailService,
    private router: Router
  ) {
    this.email = {} as PublicFormContact;
    if (location.pathname.replace(/\//g, '')) {
      this.router.navigateByUrl('login');
    }
  }

  public sendBusinessEmail() {
    this.processando = true;
    this.bootboxAlertComId = new DefineBootboxId();
    this.sendMailService.sendMail(this.email)
      .pipe(first(),
        finalize(() => {
          this.processando = false;
        }))
      .subscribe(
        success => {
          this.bootboxAlertComId.alerta('E-mail enviado com sucesso.');
          this.eraserForm();
        },
        error => {
          this.bootboxAlertComId.alerta(error._body);
        }
      )
  }

  private eraserForm() {
    this.email = {} as PublicFormContact;
  }

  public navigateTo(elementId: string) {
    return document.getElementById(elementId).scrollIntoView();
  }

}



// WEBPACK FOOTER //
// ./src/app/public/institucional/institucional.component.ts